import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { Store } from './redux/Store';
import _ from 'lodash'
import generateRoutes from './routes';
import PopUpLogin from './auth/PopUpLogin';

const App = () => {
  const apps = JSON.parse(localStorage.getItem("apps")) || [];
  const appmenu = _.map(apps, a => Number(a.MenuId));

  const dynamicRoutes = generateRoutes(appmenu);
  const content = useRoutes(dynamicRoutes);

  const [loginModalOpen, setLoginModalOpen] = useState(false);

  useEffect(() => {
    const handler = () => {
      const iframe = document.querySelector('iframe');
      if (iframe) {
        iframe.style.zIndex = '0';
      }
      setLoginModalOpen(true);
    };

    window.addEventListener('show-login-popup', handler);
    return () => window.removeEventListener('show-login-popup', handler);
  }, []);

  useEffect(() => {
    if (!loginModalOpen) return;

    const iframe = document.querySelector('iframe');
    if (!iframe) {
      const observer = new MutationObserver(() => {
        const iframe = document.querySelector('iframe');
        if (iframe) {
          iframe.style.zIndex = '0';
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return () => observer.disconnect();
    }
  }, [loginModalOpen]);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <AuthProvider>
            {content}
            <PopUpLogin
              open={loginModalOpen}
              onClose={() => {
                const iframe = document.querySelector('iframe');
                if (iframe) iframe.style.zIndex = '2147483647';
                setLoginModalOpen(false);
              }}
            />
          </AuthProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
